import { HotkeyCommand, Hotkeys } from 'owa-hotkeys/lib/types/HotkeyCommand';

/**
 * Creates a copy of a hotkey with at most one hotkey per entry
 */
export function getFirstHotkey(key: HotkeyCommand): HotkeyCommand {
    return {
        ...key,
        hotmail: getKey(key.hotmail),
        yahoo: getKey(key.yahoo),
        gmail: getKey(key.gmail),
        owa: getKey(key.owa),
    };
}

function getKey(keyString: Hotkeys): string & Hotkeys {
    return keyString instanceof Array ? (keyString.length ? keyString[0] : undefined) : keyString;
}
